import { freeImageRoutingVersion, subscribeFreeImageRouting } from "./free-image-rollout-routing";
import { useCallback, useContext, useSyncExternalStore } from "react";
import {
    ImageValidationRenderingContext,
    FreeImageRoutingRenderingContext,
} from "./image-validation-rendering-context";
import { imageValidationRenderingVersion, subscribeImageValidationRendering } from "./image-validation-worker";

/** Recompute selected-app image URLs in place; component identity and local state survive. */
export function useImageValidationRendering(appID: string): void {
    const enabled = useContext(ImageValidationRenderingContext);
    const subscribe = useCallback(
        (changed: () => void) => (enabled ? subscribeImageValidationRendering(appID, changed) : () => undefined),
        [appID, enabled]
    );
    const snapshot = useCallback(() => imageValidationRenderingVersion(appID), [appID]);
    useSyncExternalStore(subscribe, snapshot, () => 0);
    const freeEnabled = useContext(FreeImageRoutingRenderingContext);
    const subscribeFree = useCallback(
        (changed: () => void) => (freeEnabled ? subscribeFreeImageRouting(appID, changed) : () => undefined),
        [appID, freeEnabled]
    );
    const freeSnapshot = useCallback(() => freeImageRoutingVersion(appID), [appID]);
    useSyncExternalStore(subscribeFree, freeSnapshot, () => 0);
}
